import { CompoundFilter } from '@trukt/ui/CompoundFilter';
import { ReportSaveFormContainer } from './ReportSaveFormContainer';
import { ColumnSettingsCard, ColumnsSettingsCardProps } from '@trukt/ui/columns-settings-card';
import { GetOrdersRequest, GetReportResponse } from '@api';
import { OrderListCompoundFilterState } from '../hooks/use-order-list-compound-filter';
import { COLUMN_DICTIONARY, COLUMN_GROUPS } from '../OrderListView.constants';

interface OrderListTopicProps extends Pick<
  ColumnsSettingsCardProps,
  'columnVisibility' | 'onVisibilityChange'
> {
  isReportView: boolean;
  data?: GetReportResponse;
  ordersRequestValues: GetOrdersRequest['body']['filters'];
  orderListCompoundFilter: OrderListCompoundFilterState;
  visibileColumns: string[];
}
export const OrderListTopic = ({
  isReportView,
  data,
  orderListCompoundFilter,
  ordersRequestValues,
  visibileColumns,
  ...props
}: OrderListTopicProps) => {
  return (
    <div className="relative flex flex-1 justify-between gap-5">
      <CompoundFilter.Items />
      <div className="flex items-center gap-5">
        <ReportSaveFormContainer
          report={data}
          isReportView={isReportView}
          filters={ordersRequestValues || {}}
          getVisibleColumns={() => visibileColumns}
          compoundFilterState={orderListCompoundFilter}
        />

        <ColumnSettingsCard
          className={{ cardRoot: 'top-12' }}
          dictionary={COLUMN_DICTIONARY}
          columnGroups={COLUMN_GROUPS}
          {...props}
        />
      </div>
    </div>
  );
};
